document.addEventListener('DOMContentLoaded', function () {
  const form = document.getElementById('contact-form');
  const flashMessagesContainer = document.getElementById('flash-messages');

  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();

      const submitButton = this.querySelector('form button.btn');
      if (submitButton) {
        submitButton.classList.add('js-sending');
        submitButton.disabled = true;
      }

      const formData = new FormData(form);

      fetch(form.getAttribute('action') || window.location.href, {
        method: 'POST',
        body: formData,
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
        },
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
          return response.json();
        })
        .then((data) => {
          if (submitButton) {
            submitButton.classList.remove('js-sending');
            submitButton.disabled = false;
          }

          flashMessagesContainer.innerHTML = '';
          function createFlashMessage(label, message) {
            // <div class="alert">
            const alertWrapper = document.createElement('div');
            alertWrapper.className = 'alert';

            // <div class="alert--{{ label }}">
            const alertLabelDiv = document.createElement('div');
            alertLabelDiv.className = 'alert--' + label;

            // <div class="alert__body">
            const alertBody = document.createElement('div');
            alertBody.className = 'alert__body';

            // <div class="alert__content">
            const alertContent = document.createElement('div');
            alertContent.className = 'alert__content';

            // <div class="alert__icon">
            const alertIcon = document.createElement('div');
            alertIcon.className = 'alert__icon';

            // <span class="icon icon--icon-alert">
            const iconSpan = document.createElement('span');
            iconSpan.className = 'icon icon--icon-alert';

            // <svg class="icon__svg">
            const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
            svg.classList.add('icon__svg');

            // <use xlink:href="#icon-alert"></use>
            const use = document.createElementNS('http://www.w3.org/2000/svg', 'use');
            use.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', '#icon-alert');
            svg.appendChild(use);

            // <p>{{ message }}</p>
            const p = document.createElement('p');
            p.textContent = message;

            iconSpan.appendChild(svg);
            alertIcon.appendChild(iconSpan);
            alertContent.appendChild(alertIcon);
            alertContent.appendChild(p);
            alertBody.appendChild(alertContent);
            alertLabelDiv.appendChild(alertBody);
            alertWrapper.appendChild(alertLabelDiv);

            setTimeout(() => {
              if (alertWrapper.parentNode) {
                alertWrapper.parentNode.removeChild(alertWrapper);
              }
            }, 5000);

            return alertWrapper;
          }

          if (data.success) {
            const flashMessage = createFlashMessage('success', data.success);
            flashMessagesContainer.appendChild(flashMessage);

            form.reset();
          } else if (data.errors) {
            data.errors.forEach((error) => {
              const flashMessage = createFlashMessage('error', error);
              flashMessagesContainer.appendChild(flashMessage);
            });
          }
        })
        .catch((error) => {
          console.error('Error:', error);
          if (submitButton) {
            submitButton.classList.remove('js-sending');
            submitButton.disabled = false;
          }
        });
    });
  }
});

document.addEventListener('DOMContentLoaded', function () {
  const forms = document.querySelectorAll('.modal__form');

  function createFlashMessage(label, message) {
    const alertWrapper = document.createElement('div');
    alertWrapper.className = 'alert';

    const alertLabelDiv = document.createElement('div');
    alertLabelDiv.className = 'alert--' + label;

    const alertBody = document.createElement('div');
    alertBody.className = 'alert__body';

    const alertContent = document.createElement('div');
    alertContent.className = 'alert__content';

    const alertIcon = document.createElement('div');
    alertIcon.className = 'alert__icon';

    const iconSpan = document.createElement('span');
    iconSpan.className = 'icon icon--icon-alert';

    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.classList.add('icon__svg');

    const use = document.createElementNS('http://www.w3.org/2000/svg', 'use');
    use.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', '#icon-alert');
    svg.appendChild(use);

    const p = document.createElement('p');
    p.textContent = message;

    iconSpan.appendChild(svg);
    alertIcon.appendChild(iconSpan);
    alertContent.appendChild(alertIcon);
    alertContent.appendChild(p);
    alertBody.appendChild(alertContent);
    alertLabelDiv.appendChild(alertBody);
    alertWrapper.appendChild(alertLabelDiv);

    setTimeout(() => {
      if (alertWrapper.parentNode) {
        alertWrapper.parentNode.removeChild(alertWrapper);
      }
    }, 5000);

    return alertWrapper;
  }

  forms.forEach((form) => {
    form.addEventListener('submit', function (e) {
      e.preventDefault();

      const submitButton = this.querySelector('form button.btn');
      if (submitButton) {
        submitButton.classList.add('js-sending');
        submitButton.disabled = true;
      }

      const formData = new FormData(this);
      const flashMessagesContainer = this.closest('.modal')?.querySelector('.flash-messages') || document.getElementById('flash-messages');

      fetch(this.getAttribute('action') || window.location.href, {
        method: 'POST',
        body: formData,
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          Accept: 'application/json',
        },
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
          return response.json();
        })
        .then((data) => {
          if (submitButton) {
            submitButton.classList.remove('js-sending');
            submitButton.disabled = false;
          }

          if (flashMessagesContainer) {
            flashMessagesContainer.innerHTML = '';
          }

          if (data.success) {
            const flashMessage = createFlashMessage('success', data.message);
            flashMessagesContainer?.appendChild(flashMessage);

            this.reset();
            setTimeout(() => {
              const modal = this.closest('.modal');
              if (modal) {
                modal.classList.remove('is-open');
                document.body.classList.remove('is-unscrollable');
              }
            }, 300);
          } else if (data.errors) {
            data.errors.forEach((error) => {
              const flashMessage = createFlashMessage('error', error);
              flashMessagesContainer?.appendChild(flashMessage);
            });
          }
        })
        .catch((error) => {
          console.error('Chyba při odesílání formuláře:', error);
          if (submitButton) {
            submitButton.classList.remove('js-sending');
            submitButton.disabled = false;
          }
          const flashMessage = createFlashMessage('error', 'Chyba při odesílání formuláře.');
          flashMessagesContainer?.appendChild(flashMessage);
        });
    });
  });
});
